import {Pinia} from "pinia";
import { informationStore } from "@/store/information/data";

export const myInformationStore = {
    informationStore: (pinia?: Pinia) => informationStore(pinia),
}
